import LockupPrice from './lockupPrice'

export default LockupPrice
